import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
 

const Technology = () => {
  // Set the default active card index to 0 (first card is active by default)
  const [activeIndex, setActiveIndex] = useState(0);

 const technologies = [
  { title: "SAP Enterprise Systems", category: "ENTERPRISE", image: "./images/sap-enterprise-systems.jpg" },
  { title: "Salesforce Platforms", category: "CRM", image: "./images/salesforce-platforms.jpg" },
  { title: "Oracle Cloud and Database Solutions", category: "DATABASE", image: "./images/oracle-cloud-database.jpg" },
  { title: "Microsoft Cloud Solutions", category: "CLOUD", image: "./images/microsoft-cloud-solutions.jpg" },
  { title: "AWS Cloud Solutions", category: "INFRASTRUCTURE", image: "./images/aws-cloud-solutions.jpg" },
  { title: "NetSuite Enterprise Solutions", category: "ERP", image: "./images/netsuite-enterprise-solutions.jpg" }
];

  return (
    <section className="technology-section bg-dark text-white py-5 px-3 px-md-5">
      <div className="container-fluid">
        {/* Top Header Section */}
        <div className="row mb-5 align-items-start pt-4 text-center">
          <div className="col-lg-12 col-md-12">
            <h1 className="display-4 font-weight-bold headline-text">
               Our  
            </h1>
            <div className="brand-logo mt-4">Technologies</div>
          </div>
          
           
        </div>

        {/* Interactive Cards Section */}
        <div className="tech-cards-container d-flex flex-nowrap mt-5">
          {technologies.map((tech, index) => {
            const isActive = activeIndex === index;
            
            return (
              <div
                key={index}
                className={`tech-card-wrapper transition-all ${isActive ? 'expanded' : 'collapsed'}`}
                onMouseEnter={() => setActiveIndex(index)}
                style={{ backgroundImage: `url(${tech.image})`}}
              >
                {/* Horizontal / Standard Layout (Visible when Active) */}
                <div className="card-content-expanded p-4 d-flex flex-column justify-content-between h-100">
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="badge badge-outline-light text-uppercase tracking-wider">
                      {tech.category}
                    </span>
                  </div>
                  <div className="card-footer-info">
                    <h3 className="h4 text-white font-weight-bold mb-1">{tech.title}</h3>
                    <p className="text-light-50 small m-0 text-uppercase tracking-widest">{tech.category}</p>
                  </div>
                </div>

                {/* Vertical Text Layout (Visible when Collapsed/Inactive) */}
                <div className="card-content-collapsed d-flex flex-column align-items-center justify-content-between py-4 h-100">
                  <div className="vertical-title font-weight-bold text-uppercase">
                    {tech.title}
                  </div>
                  <div className="vertical-subtitle small tracking-widest text-light-50 font-weight-light">
                    {tech.category}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Footer Subtext */}
        <div className="text-center mt-5 pt-4">
          <p className="text-secondary tracking-wide mb-1">Let's Make Something</p>
          <h2 className="h4 font-weight-light">Extraordinary <span className="font-weight-bold text-white">Together</span></h2>
        </div>
      </div>
    </section>
  );
};

export default Technology;